import { ROLE_TYPES } from "../../constants/roleTypes";
import "./RoleShareToggle.css";

export default function RoleShareToggle({ value = [], onChange }) {
  const toggle = (role) => {
    onChange(value.includes(role) ? value.filter((r) => r !== role) : [...value, role]);
  };
  return (
    <div className="role-share-toggle">
      {ROLE_TYPES.map((role) => (
        <button
          type="button"
          key={role}
          className={`role-share-toggle-btn ${value.includes(role) ? "selected" : ""}`}
          onClick={() => toggle(role)}
        >
          {role}
        </button>
      ))}
    </div>
  );
}
